import { rest } from "msw"
import { delay } from "../../../utils"

export const config = [
  rest.get("*/v1/stores/:storeID/config/", function(_req, res, ctx) {
    return res(delay(ctx), ctx.json(require("./get.fixture.json")))
  }),
]
